// src/pages/projects/content/Project1Content.js
import React from 'react';
import '../../../styles/ProjectContent.css';

export default function Project1Content() {
    return (
        <div className = "project-content-box">
            <h2>Digital Logic Hole in the Wall</h2>
            <p>
                The digital logic minigame was made for the ECE150 - Digital
                Logic Design course during the Cooper Union Spring 2023 semester. 
                This was an introductory class to digital logic circuits, focusing 
                on applications using CMOS and TTL chips, using components like 
                flip-flops, counters, multiplexers, 555 timers, and much more. 
            </p>

            <p>
                This Hole in the Wall minigame is similar to the old American 
                television show except instead of people trying to fit through a
                wall, it's an LED traveling down a matrix, trying not to collide
                with the LED wall in the way. To dodge the wall of LEDs, a user must
                press the 'left' or 'right' button, moving the LED horizontally 
                to the left or right in the matrix. If the user LED collides with
                the wall LED, then the 'life' indicator LED turns red and the user
                must click the 'reset game' button to play again.
            </p>

            <div className="image-gallery">
                <div className="gallery-item">
                    <img src="/projects/project2/dld_final_game_review.png" alt="Game in action" />
                    <div className="gallery-caption">Game details</div>
                </div>
            </div>
            
            <p>
                In this project, I worked with two other classmates, Isaac Shertz (EE'26)
                and Morris Madeb (EE'26). First, we came up with an overview of what the 
                game should look like at a high level, and then each made our own
                versions of the game in Logisim-evolution. After a week of desigining
                our own simulations, we came back together and combined the best parts
                of each of our simulations to create an efficient 12 chip solution.
                We then layed out how we should order the chips on the breadboard
                for maximum wiring efficiency and then started to wire.
            </p>

            <div className="image-gallery">
                <div className="gallery-item">
                    <img src="/projects/project2/dld_final_project_prep.png" alt="Circuit design" />
                    <div className="gallery-caption">High level overview on whiteboard</div>
                </div>

                <div className="gallery-item">
                    <img src="/projects/project2/dld_final_project_overlay.png" alt="Overlay view" />
                    <div className="gallery-caption">Breadboard chip layout</div>
                </div>
            </div>

            <p> 
                On the techinical side, a D flip-flop controls the game-over state, 
                a 2-bit mod 4 counter controlled using two D flip-flops and buttons 
                (actuating the clock on the D flip-flop) controls the horizontal position, 
                and a shift register controls the vertical position. The game is 
                controlled by a 1 Hz clock, generated using a 555 timer and the
                barrier is 'randomly' generated by sticking a really fast clock
                onto a presettable up/down counter. The collision logic just AND's 
                the output of the horizontal position (when the LED is past the 
                last row in the matrix) with the barrier LED values and if there 
                is a 1, there is a collision and the game is over. 
            </p>
            <p>
                Over the course of three weeks leading up to the demo, 
                we all took turns wiring the project when we could and updated 
                each other on the progress we made along the way. Check out the 
                video demonstration below to see our final project in action!
            </p>

            <div className="image-gallery">
                <div className="gallery-item">
                    <img
                        src="/projects/project2/dld_final_project_board.png"
                        alt="Breadboard chip layout"
                    />
                    <div className="gallery-caption">Breadboard chip layout</div>
                </div>

                <div className="gallery-item">
                    <iframe
                        width="auto" height="250"
                        src="https://www.youtube.com/embed/UITD9vimViQ"
                        title="Digital Hole in the Wall Demo"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    />
                    <div className="gallery-caption">Final project demo video</div>
                </div>
            </div>
        </div>
    );
}

